export { default as Layout } from './Layout';
export {
  createLayoutConfigProps,
  getLayoutConfigPageProps,
} from './Layout.prop';
